export default __webpack_public_path__ + "static/admin-dashboard-e89661b8b238fbaa40e0b85322be8f66.png";